import { WebGLRenderer } from 'three';

function createRenderer(container) {
  const renderer = new WebGLRenderer({antialias: true, canvas: container});
  // 打开物理上正确的照明
  renderer.physicallyCorrectLights = true;
  return renderer;
}

export { createRenderer };